<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.Task">
        <h1 class="title">{{ $t("entities.tasks") }}</h1>
      </page-header>

      <datatable :fetch="fetchTasks" ref="taskList" objectName="tasks" order="DESC">
        <div slot="id" slot-scope="{ item }" title="ID" :sortable="true" nofilter>
          {{ item.id }}
        </div>
        <div slot="jobId" slot-scope="{ item }" title="JobId" :sortable="true" nofilter>
          {{ item.jobId }}
        </div>
        <div
          slot="objectName"
          slot-scope="{ item }"
          title="Entity"
          :sortable="true"
        >
          {{ item.objectName }}
        </div>
        <div
          slot="objectId"
          slot-scope="{ item }"
          title="Entity ID"
          :sortable="true"
          type="number"
        >
          {{ item.objectId }}
        </div>
        <div
          slot="creator.name"
          slot-scope="{ item }"
          title="Creator"
          :sortable="true"
          sortBy="creator.name"
          nofilter
        >
          {{ item.creator ? item.creator.name : "" }}
        </div>
        <div
          slot="status"
          slot-scope="{ item }"
          title="Status"
          :sortable="true"
          advancedFilter
          :advancedFilterOptions="statusFilterOptions"
          nofilter
        >
          <span
            class="tag"
            :class="{
              'is-info': item.status === 'CREATED',
              'is-success': item.status === 'SUCCESS',
              'is-danger':
                item.status === 'ERROR' || item.status === 'FAILED',
              'is-warning': item.status === 'PROCESSING',
            }"
          >
            {{ item.status }}
          </span>
        </div>
        <div
          slot="createdAt"
          slot-scope="{ item }"
          title="Created At"
          :sortable="true"
          nofilter
        >
          {{ item.createdAt | datetime }}
        </div>
        <div slot="events" slot-scope="{ item }" title="Events" nofilter>
          <div v-for="(event, index) in item.events || []" :key="index">
            <b>{{ event.time | datetime }}</b> {{ event.name }}
            <div
              v-if="event.description"
              style="text-wrap: wrap; word-break: break-word"
            >
              {{ event.description }}
            </div>
          </div>
        </div>
      </datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/Datatable";
import axios from "axios";
export default {
  name: "TaskList",
  components: {
    Datatable,
  },
  data() {
    return {
      statusFilterOptions: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Created",
          value: "CREATED",
        },
        {
          label: "Processing",
          value: "PROCESSING",
        },
        {
          label: "Success",
          value: "SUCCESS",
        },
        {
          label: "Error",
          value: "ERROR",
        },
        {
          label: "Failed",
          value: "FAILED",
        },
      ],
    };
  },
  methods: {
    fetchTasks(pagination) {
      const filters = { ...pagination.filters };
      if (filters.objectName) {
        filters.entity = filters.objectName;
        delete filters.objectName;
      }
      if (filters.objectId) {
        filters.entityId = filters.objectId;
        delete filters.objectId;
      }
      return axios.get("/tasks", {
        params: {
          ...pagination,
          filters,
        },
        paramsSerializer: (params) => {
          const search = new URLSearchParams();
          search.set("page", params.page);
          search.set("size", params.size);
          search.set(
            "sort",
            `${params.sort.column},${params.sort.direction.toLowerCase()}`
          );
          Object.entries(params.filters || {}).forEach(([key, value]) => {
            if (value) {
              search.set(key, value);
            }
          });
          return search.toString();
        },
      }).then((response) => response.data);
    },
  },
};
</script>
